export default __webpack_public_path__ + "static/media/Zeke.380b9135.png";